import axios from "axios";
import config from "../config";
import {getPatientToken} from '../utils'

const getScheduleTimingListApi = async (params) => {
  const response = await axios({
    url: `${config.api.base_url}schedule-timing/get-slot-by-day-and-date`,
    method: "get",
    params: params,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getPatientToken()}`
    },
  });

  return response;
};

export default getScheduleTimingListApi;
